export const CARDS_VERSION_2 = '2';
export const CARDS_VERSION_3 = '3';
